// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__1fRbX","modal__remainbutton":"deleteModal_modal__remainbutton__1PgZ1","modal__deletebutton":"deleteModal_modal__deletebutton__VP5hE"};